module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "scrollContainer",
    staticClass: "content"
  }, [_c('div', {
    staticClass: "account-ds"
  }, [_c('div', {
    staticClass: "bar bar-nav account-top-m"
  }, [_c('router-link', {
    staticClass: "button button-link button-nav pull-left",
    attrs: {
      "to": "/customer/account/index"
    }
  }, [_c('span', {
    staticClass: "icon icon-left"
  })]), _vm._v(" "), _c('h1', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t("message.product_favorite")))])], 1)]), _vm._v(" "), (_vm.errormsg) ? _c('div', {
    staticClass: "fecshop_message"
  }, [_c('div', {
    staticClass: "error-msg"
  }, [_c('div', [_vm._v("\n                    " + _vm._s(_vm.errormsg) + "\n                ")])])]) : _vm._e(), _vm._v(" "), (_vm.correctmsg) ? _c('div', {
    staticClass: "fecshop_message"
  }, [_c('div', {
    staticClass: "correct-msg"
  }, [_c('div', [_vm._v("\n                    " + _vm._s(_vm.correctmsg) + "\n                ")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "account-container"
  }, [_c('div', {
    staticClass: "col-main account_center"
  }, [_c('div', {
    staticClass: "std"
  }, [_c('div', {
    staticStyle: {
      "margin": "4px 0 0"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "min-height": "500px"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [(_vm.pageInitComplete && _vm.productList.length > 0) ? _c('table', {
    staticClass: "product-Reviews"
  }, _vm._l((_vm.productList), function(itemProduct, index) {
    return _c('tr', [_c('td', [_c('router-link', {
      attrs: {
        "to": '/catalog/product/' + itemProduct.product_id
      }
    }, [_c('p', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_c('img', {
      attrs: {
        "src": itemProduct.imgUrl,
        "width": "75",
        "height": "75"
      }
    })])])], 1), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "review_description_right_span"
    }, [_c('b', [_c('router-link', {
      attrs: {
        "to": '/catalog/product/' + itemProduct.product_id
      }
    }, [_vm._v("\n                                                    " + _vm._s(itemProduct.name) + "\n                                                ")])], 1)]), _vm._v(" "), _c('div', {
      staticClass: "review_description_centen"
    }, [(itemProduct.price_info && itemProduct.price_info.special_price) ? _c('div', {
      staticClass: "price_info"
    }, [_c('div', {
      staticClass: "special_price special_active"
    }, [_vm._v("\n                                                        " + _vm._s(itemProduct.price_info.special_price.symbol) + "\n                                                        " + _vm._s(itemProduct.price_info.special_price.value) + "\n                                                    ")]), _vm._v(" "), _c('div', {
      staticClass: "price special_active"
    }, [_vm._v("\n                                                        " + _vm._s(itemProduct.price_info.price.symbol) + "\n                                                        " + _vm._s(itemProduct.price_info.price.value) + "\n                                                    ")]), _vm._v(" "), _c('div', {
      staticClass: "clear"
    })]) : (itemProduct.price_info && itemProduct.price_info.price) ? _c('div', {
      staticClass: "price_info"
    }, [_c('div', {
      staticClass: "price no-special"
    }, [_vm._v("\n                                                        " + _vm._s(itemProduct.price_info.price.symbol) + "\n                                                        " + _vm._s(itemProduct.price_info.price.value) + "\n                                                    ")])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "clear"
    }), _vm._v(" "), _c('div', {
      staticStyle: {
        "font-weight": "100"
      }
    }, [_vm._v("\n                                                    Favorite Date:" + _vm._s(itemProduct.updated_at) + "\n                                                ")])])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "favorite-Operation addressbook ",
      staticStyle: {
        "display": "inline-block",
        "float": "right",
        "margin-top": "0px"
      }
    }, [_c('a', {
      attrs: {
        "external": "",
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          return _vm.removeFavorite(itemProduct.favorite_id)
        }
      }
    }, [_c('span', {
      staticClass: "icon icon-remove"
    })])])])])
  }), 0) : _vm._e(), _vm._v(" "), _c('mugen-scroll', {
    attrs: {
      "handler": _vm.fetchProduct,
      "should-handle": !_vm.loading,
      "scroll-container": "scrollContainer"
    }
  }, [_c('div', {
    staticClass: "infinite-scroll-preloader",
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "preloader"
  })])]), _vm._v(" "), (_vm.pageInitComplete && _vm.productList.length <= 0) ? _c('div', [_vm._v("\n                                    You have no items in your favorite.\n                                ")]) : _vm._e()], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4d06c12c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/body/customer/Productfavorite.vue
// module id = 245
// module chunks = 1